import { render, staticRenderFns } from "./MergePPTXModal.vue?vue&type=template&id=be2ac038&scoped=true"
import script from "./MergePPTXModal.vue?vue&type=script&lang=js"
export * from "./MergePPTXModal.vue?vue&type=script&lang=js"
import style0 from "./MergePPTXModal.vue?vue&type=style&index=0&id=be2ac038&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2ac038",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be2ac038')) {
      api.createRecord('be2ac038', component.options)
    } else {
      api.reload('be2ac038', component.options)
    }
    module.hot.accept("./MergePPTXModal.vue?vue&type=template&id=be2ac038&scoped=true", function () {
      api.rerender('be2ac038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/MergePPTXModal.vue"
export default component.exports